import axios from 'axios'
import NProgress from 'nprogress'

/**
 * 工具箱后端（wxtools）接口
 *
 * 与博客自身的 blog-api 是两套服务，响应结构也不同（若依的 {code,msg,data}），
 * 所以这里单开一个实例，不复用 @/plugins/axios。
 *
 * 生产走 /wx-api 同域反代到 127.0.0.1:8100，
 * 因为博客是 HTTPS，直连后端 IP 会被浏览器按混合内容拦截。
 */
const request = axios.create({
	baseURL: process.env.VUE_APP_WX_API || '/wx-api',
	timeout: 10000
})

request.interceptors.request.use((config) => {
	NProgress.start()
	return config
})

request.interceptors.response.use(
	(response) => {
		NProgress.done()
		return response.data
	},
	(error) => {
		NProgress.done()
		return Promise.reject(error)
	}
)

/** 已上架的工具清单，顺序与上下架由后台控制 */
export function getToolList() {
	return request({
		url: '/app-api/tool/list',
		method: 'GET'
	})
}

/** 上报一次工具使用，用于后台的热门排行 */
export function reportToolUse(toolKey) {
	return request({
		url: '/app-api/tool/use',
		method: 'POST',
		data: {toolKey}
	})
}

/** 技能树 */
export function getSkillTree() {
	return request({
		url: '/app-api/skill/tree',
		method: 'GET'
	})
}

/** 最近的学习打卡记录 */
export function getSkillLogs() {
	return request({
		url: '/app-api/skill/logs',
		method: 'GET'
	})
}

/** 项目预算参考。后台开关关闭时 enabled 为 false 且不下发任何条目 */
export function getPriceList() {
	return request({
		url: '/app-api/price/list',
		method: 'GET'
	})
}

/** 提交合作需求 */
export function submitLead(data) {
	return request({
		url: '/app-api/lead/submit',
		method: 'POST',
		data
	})
}
